import React, { useState, useMemo, useEffect, useRef } from "react";
import bg from "../../../../../img/LOGO.webp";
import IconTick from "../../../../../img/icon-tick.gif";
import Loading from "../../../../../Others/Loading";
import { useSelector, useDispatch } from "react-redux";
import {
  getOrderDetailsRashan,
  placeOrder,
} from "../../../../../Request/OrderRequests";
import { clearCart } from "../../../../../Redux/Actions/userActions";
import { match, round } from "../../../../../Others/functions";
import { useLocation, useNavigate } from "react-router";
import cookie from "react-cookies";
const vendorId = "37cfbaa0cdd335e81abd4aba05c5e254";
const PlaceOrder = () => {
  const [bill, setBill] = useState(null);
  const executed = useRef(false);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const store = "Rashan-4";
  const { state } = useLocation();
  const paymentMethodDetails = useSelector(
    (state) => state.user.onlinePaymentDetails
  );
  const [isLoading, setIsLoading] = useState(true);
  const address = useSelector((state) => state.user?.address);
  const cart = useSelector(
    (state) =>
      state.user.cart?.filter((c) => c.vendorId === vendorId)?.[0]?.cart
  );
  const userId = useSelector((state) => state.user.info?.userHash);

  const info = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.info
  );
  const selected = useMemo(() => {
    const primary = address?.filter((element) => element.primary);
    return primary;
  }, [address]);

  useEffect(() => {
    if (cart?.length) {
      let temp = cart.reduce((t, product) => {
        let MRP = t.MRP || 0;
        let productDiscount = t?.["Product discount"] || 0;
        let slabDiscount = t?.["Slab discount"] || 0;
        let freeProduct = t?.["Free item discount"] || 0;
        let total = t.Total || 0;

        MRP += product.mrp * product.qty;
        productDiscount += (product.mrp - product.sp) * product.qty;
        slabDiscount += (product.sp - product.finalSp) * product.qty;
        freeProduct += product.free * product.mrp;
        total += product.finalSp * product.qty;

        t = {
          MRP: round(MRP, 2),
          "Product discount": round(productDiscount, 2),
          "Slab discount": round(slabDiscount, 2),
          "Free item discount": round(freeProduct, 2),
          Total: round(total, 2),
          "Coupon discount": 0,
        };
        return t;
      }, {});

      if (state && state?.coupon.billAmount <= temp.Total) {
        let coupon = state.coupon;
        let discount;
        if (coupon.discountType === "Flat Discount") {
          discount = coupon.amount;
        } else {
          discount = round((temp?.Total * coupon.percent) / 100, 2);
          if (
            coupon.maxDiscount &&
            parseFloat(discount) > parseFloat(coupon.maxDiscount)
          ) {
            discount = coupon.maxDiscount;
          }
        }
        temp.Total = round(temp.Total - discount, 2);
        temp["Coupon discount"] = discount;
      }

      let offer = false;

      if (
        info?.cartOfferFlag3 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue3)
      )
        offer = info.cartOffer3;
      else if (
        info?.cartOfferFlag2 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue2)
      )
        offer = info.cartOffer2;
      else if (
        info?.cartOfferFlag1 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue1)
      )
        offer = info?.cartOffer1;

      if (offer) {
        let discount = round((temp?.Total * offer) / 100, 2);
        temp["cart discount"] = {
          pcnt: offer,
          str: `${offer}% cart discount`,
          amt: discount,
        };
        temp["Grand Total"] = round(temp.Total - discount, 2);
      }

      temp.saved = Object.keys(temp).reduce(
        (sum, type) =>
          type.includes("discount")
            ? type === "cart discount"
              ? (sum += temp[type].amt)
              : (sum += temp[type])
            : sum,
        0
      );

      setBill(temp);
    }
  }, [cart, info, state]);

  const placeOrderFX = () => {
    if (executed.current) {
      return;
    }

    let order = {
      userId,
      vendorId: 4,
      orderDate: new Date(),
      orderCount: cart?.length,
      productDiscount: bill?.["Product discount"] || 0,
      slabDiscount: bill?.["Slab discount"] || 0,
      freeDiscount: bill?.["Free item discount"] || 0,
      cartDiscountPcnt: bill?.["cart discount"]?.pcnt || 0,
      cartDiscountAmt: bill?.["cart discount"]?.amt || 0,
      orderMrp: bill?.MRP,
      orderTotal: bill.Total,
      orderGTotal: bill?.["Grand Total"] || bill.Total,
      addressId: selected[0].addressId,
      name: selected[0].name,
      paymentMethod: paymentMethodDetails?.paymentMethod || "COD",
      paytmOrderId: paymentMethodDetails?.paytmOrderId || 0,
      paytmTxnNo: paymentMethodDetails?.paytmTxnNo || 0,
      //add_savings
    };

    // insert in subOrder
    let subOrder = cart?.map((product) => [
      product.pID,
      product.sp,
      product.mrp,
      product.finalSp,
      product.free,
      product.qty,
      product.free_item,
      new Date(),
      4,
    ]);
    // console.log({
    //   userId,
    //   selectedAddID: selected[0].addressId,
    //   vendorId,
    //   order,
    //   subOrder,
    // });
    placeOrder(userId, selected[0].addressId, vendorId, { order, subOrder })
      .then((res) => {
        setIsLoading(false);
        dispatch(clearCart(vendorId));

        getOrderDetailsRashan(cookie.load("uid"))
          .then((orderRes) => {
            const orderIndex = orderRes.findIndex((order) => {
              if (order?.vendor_order_no === res?.orderNo) {
                return true;
              }
            });
            if (orderIndex !== -1) {
              setTimeout(() => {
                navigation(`/orderstatus/${orderRes[orderIndex]?.order_id}`, {
                  replace: true,
                });
              }, 3000);
            }
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.error(err))
      .finally(() => {
        executed.current = true;
      });
  };

  useEffect(() => {
    if (executed.current) {
      return;
    }

    if (!address || !cart || !userId || !bill || cart.length === 0) {
      return;
    }
    //place order
    placeOrderFX();
    //clear cart
  }, [address, cart, userId, bill, cart, info]);

  return isLoading ? (
    <Loading />
  ) : (
    <>
      {/* *************************** Thank you Page Start ***************************** */}
      <div
        className="thankYou"
        style={{
          position: "fixed",
          zIndex: "9999",
          top: "0",
          left: "0",
          bottom: "0",
          width: "100vw",
          overflow: "hidden",
          background: "#fff",
          transition: "ease 0.4s",
        }}
      >
        <div
          className="splash"
          style={{
            position: "relative",
            zIndex: "999",
            width: "150%",
            left: "-25%",
            background: "linear-gradient(180deg, #9C2F46 0%, #D66167 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={bg} alt="" style={{ width: "124px" }} />
        </div>
        <div
          style={{
            position: "relative",
            zIndex: "999",
            background: "#fff",
            height: "60vh",
            paddingTop: "32px",
          }}
        >
          <img
            src={IconTick}
            width={200}
            style={{ display: "block", margin: "0 auto 16px" }}
          />
          <h1
            style={{
              fontSize: "18px",
              fontWeight: "700",
              textAlign: "center",
              margin: "0 0 16px",
              color: "rgba(43, 43, 43, 1)",
            }}
          >
            Order Confirmed
          </h1>
          {bill?.saved ? (
            <div className="savingthankyou">
              <h3>₹{bill?.saved} savings</h3>
              <h5>Thank you !</h5>
            </div>
          ) : null}
        </div>
      </div>

      {/* *************************** Thank you Page End ***************************** */}
    </>
  );
};

export default PlaceOrder;
